var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',_vm._l((_vm.day),function(o,index){return _c('v-btn',{key:index,attrs:{"small":"","text":"","color":"secondary"},on:{"click":function($event){return _vm.edit(o.id)}}},[_vm._v(_vm._s(_vm._f("minutesToTime")(o.startHH))+" - "+_vm._s(_vm._f("minutesToTime")(o.endHH)))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }